import { api } from "./api";

export interface AnnouncementItem {
  AnnouncementId: number;
  AnnouncementTypeId: number;
  AnnouncementTypeName: string;
  AnnouncementName: string;
  AnnouncementDescription: string;
  MallId: number;
  TenantId: number;
  TenantName: string;
  ImageURL: string;
  DocumentURL: string;
  IsVisible: boolean;
  Status: number;
}

export interface AnnouncementResponse {
  announcementDatas: AnnouncementItem[];
  TotalRecord: number;
  Code: number;
  Message: string;
}

export interface AnnouncementTypeItem {
  DataId: number;
  DataLabel: string;
  Description: string | null;
}

export interface AnnouncementTypeResponse {
  dropdownClassDatas: AnnouncementTypeItem[];
  TotalRecord: number;
  Code: number;
  Message: string;
}

export const GetAnnouncement = async (
  announcementid: number,
  announcementtypeid: number,
  page: number,
  number: number
) => {
  try {
    const mallid =
      localStorage.getItem("mall_id") || sessionStorage.getItem("mall_id");

    const url = `/tenant/v1/getannouncement?announcementid=${announcementid}&announcementtypeid=${announcementtypeid}&mallid=${mallid}&page=${page}&number=${number}`;
    const response = await api.get<AnnouncementResponse>(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const GetAnnouncementTypes = async () => {
  try {
    const url = `/dropdown/v1/announcementtype`;
    const response = await api.get<AnnouncementTypeResponse>(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};